import React from "react";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    position: relative;
    height: 100vh;
    isolation: isolate;
    .bg-image {
        z-index: 1;
        position: absolute;
        inset: 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
    .cover {
        z-index: 2;
        position: absolute;
        inset: 0;
        background-color: #00000088;
    }
    .data {
        z-index: 3;
        width: calc(100% - 140px);
        padding: 0 70px 8rem;
        display: flex;
        flex-direction: column;
        justify-content: end;
        text-align: center;
        .title {
            font-size: 2rem;
            font-weight: 800;
            color: #fff;
        }
    }
    @media (max-width: 850px){
        .data { 
            justify-content: end;
            width: calc(100% - 32px);
            padding: 0 16px 10rem;
        }
    }
`;

export default function IntroPage({pageHeight, data}) {
    return (
      <Style style={{height: `${pageHeight/2}px`}}>
        <div className="bg-image">
            <img src={data.data.bgimage} alt={data.title}/>
        </div>
        <div className="cover">
        </div>
        <div className="data">
            <div className="title">
                {data.data.title}
            </div>
        </div>
      </Style>
  );
}
